import { useCallback, useState } from 'react';

export const useOTPTransferData = ({ ibanTransferOTPCall, userProfile }) => {
    const [OTPTransferData, setOTPTransferData] = useState({
        date: 'XX/XX/XX',
        entityName: '',
        iban: '',
        retryTransfer: false,
    });

    const fetchOTPTransferData = useCallback(async () => {
        const transferOTPResponse = await ibanTransferOTPCall(userProfile.accessToken, 'GET');
        setOTPTransferData(transferOTPResponse);
    }, [ibanTransferOTPCall, userProfile]);

    return { OTPTransferData, setOTPTransferData, fetchOTPTransferData };
};
